// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rPvN","icon":"styles_icon__zJsxM"};